module.exports = __webpack_public_path__ + "img/browsers-inception-1.0c84eaa4.png";